import { httpClient } from './httpClient';

export interface DocumentProgress {
  documentId: string;
  viewedPages: number;
}

export interface PageViewSummaryResponse {
  totalViewedPages: number;
  documents: DocumentProgress[];
}

export const pageViewApi = {
  recordPageView: (caseId: string, documentId: string, pageNumber: number): Promise<void> =>
    httpClient.post(`/cases/${caseId}/page-views`, { documentId, pageNumber }),

  recordBatchPageViews: (caseId: string, documentId: string, pageNumbers: number[]): Promise<void> =>
    httpClient.post(`/cases/${caseId}/page-views/batch`, { documentId, pageNumbers }),

  getViewSummary: (caseId: string): Promise<PageViewSummaryResponse> =>
    httpClient.get<PageViewSummaryResponse>(`/cases/${caseId}/page-views/summary`),
};
